import Reveal from "@/components/Reveal";
import { LOGO_URL } from "@/data/catalog";
import { Play } from "lucide-react";

export default function Showreel() {
  return (
    <section id="showreel" data-testid="showreel-section" className="border-t border-[#1F1F1F] bg-[#050505] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:gap-16 lg:px-10">
        <Reveal>
          <a
            data-testid="showreel-thumbnail"
            href="https://instagram.com/cybersmokemedia"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block overflow-hidden border border-[#1F1F1F] shadow-[0_0_60px_rgba(225,29,46,0.12)]"
          >
            <img
              src={LOGO_URL}
              alt="Cyber Smoke Media showreel"
              className="aspect-video w-full object-contain object-center p-4 transition-all duration-700 group-hover:scale-[1.03]"
            />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="flex h-16 w-16 items-center justify-center rounded-full border border-white/20 bg-black/50 backdrop-blur-sm transition-all duration-300 group-hover:scale-110 group-hover:border-[#E11D2E] group-hover:bg-[#E11D2E]">
                <Play size={22} className="ml-0.5 fill-white text-white" />
              </span>
            </span>
          </a>
        </Reveal>

        <Reveal delay={0.12}>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E11D2E]">Watch our showreel</p>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[1.02] tracking-tight text-white sm:text-5xl">
            We turn visibility
            <span className="block text-[#E11D2E]">into opportunity.</span>
          </h2>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-[#8A8A8A] md:text-base">
            From artists to entrepreneurs, we help creators and brands get seen, heard, and
            remembered. Watch how we make it happen.
          </p>
          <a
            data-testid="showreel-play-btn"
            href="https://instagram.com/cybersmokemedia"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 bg-[#E11D2E] px-7 py-4 font-mono text-xs font-600 uppercase tracking-[0.14em] text-white transition-all duration-300 hover:bg-[#F13B47] hover:shadow-[0_0_32px_rgba(225,29,46,0.4)]"
          >
            Play showreel <Play size={13} className="fill-white" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
